import { DigitMode, TwoNumberPatternEnum } from '../../../BetLotto.types'
import SearchAndRotation from '../SearchAndRotation/SearchAndRotation'
import useSearchAndRotation from '../SearchAndRotation/useSearchAndRotation'
import SelectBetNumber from '../SelectBetNumber/SelectBetNumber'
import { BasePanelProps } from '../../PanelSelection.types'
import TwoNumberPattern from './TwoNumberPattern'

const TwoPanel: React.FC<BasePanelProps> = ({
  activeBetType,
  betList,
  addLottoListAndHandleResponse,
  onDeleteByNumberAndType,
  getLimitTypeUI,
}) => {
  const { searchQuery, setSearchQuery, rotated, handleRotate } =
    useSearchAndRotation()

  const onSelectBetNumber = (betNumber: string) => {
    const selectedList = betList?.filter((bet) =>
      bet.items.some((item) => item.number === betNumber),
    )
    if (selectedList?.length && selectedList?.length > 0) {
      onDeleteByNumberAndType?.(betNumber, activeBetType)
    } else {
      if (rotated) {
        addLottoListAndHandleResponse(betNumber, activeBetType, 1, {
          rotated: true,
        })
      } else {
        addLottoListAndHandleResponse?.(betNumber, activeBetType, 1)
      }
    }
  }

  const isDisabled = activeBetType?.length === 0 || !activeBetType
  return (
    <div>
      <SearchAndRotation
        digitMode={DigitMode.TWO_DIGIT}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onRotateClick={handleRotate}
        isRotated={rotated}
      />
      <div className="mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[
            TwoNumberPatternEnum.FRONT_RUNNING,
            TwoNumberPatternEnum.END_RUNNING,
            TwoNumberPatternEnum.NINETEEN_NUMBER,
          ].map((type) => (
            <TwoNumberPattern
              key={type}
              type={type}
              activeBetType={activeBetType}
              addLottoListAndHandleResponse={addLottoListAndHandleResponse}
            />
          ))}
        </div>
      </div>

      <SelectBetNumber
        digitMode={DigitMode.TWO_DIGIT}
        searchQuery={searchQuery}
        betList={betList}
        onSelectBetNumber={onSelectBetNumber}
        isDisabled={isDisabled}
        getLimitTypeUI={getLimitTypeUI}
        activeBetType={activeBetType}
      />
    </div>
  )
}

export default TwoPanel
